import React from 'react'
import ReactDayPicker from 'react-day-picker'
import MomentLocaleUtils from 'react-day-picker/moment'

import 'react-day-picker/lib/style.css'
import './index.scss'

const DayPicker = (props) => (
  <ReactDayPicker
    locale="nb"
    localeUtils={MomentLocaleUtils}
    {...props}
  />
)

export default DayPicker
